import { eventApi } from "shared/api/eventApi";

export const getAllEventsRequest = (payload, options = {}) => {
  return eventApi.getAllEvents({ ...payload, signal: options.signal });
};
